import React, { useState } from 'react';
import {
    Container,
    TextField,
    Button,
    Typography,
    Alert
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            await login(email, password);
            window.location.href = '/';
        } catch (err) {
            setError('Login fehlgeschlagen. Bitte prüfen Sie Ihre E-Mail und Ihr Passwort.');
            console.error(err);
        }
    };

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        if (error) setError('');
    };

    return (
        <Container maxWidth="xs" sx={{ marginTop: 10 }}>
            <Typography variant="h5" align="center" gutterBottom>
                Login
            </Typography>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="Händler Email"
                    variant="outlined"
                    margin="normal"
                    value={email}
                    onChange={handleInputChange(setEmail)}
                />
                <TextField
                    fullWidth
                    label="Händler Passwort"
                    variant="outlined"
                    margin="normal"
                    type="password"
                    value={password}
                    onChange={handleInputChange(setPassword)}
                />
                <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2 }}
                >
                    Login
                </Button>
            </form>
        </Container>
    );
}

export default LoginPage;
